export const dimensions = {
  addressInput: {
    height: '40px',
  },
  fontSize24: '24px',
  fontWeight500: '500',
};
